import React from 'react';
import { observer } from 'mobx-react-lite';
import { UniverseComponent } from 'src/domains/common/universes';

export const LoginImageContainer = observer(() => {
    return <UniverseComponent>{(UniverseModule) => <UniverseModule.loginImageContainer />}</UniverseComponent>;
});
